'use client';
import cn from 'classnames';

import './LineDivider.style.scss';

type LineDividerProps = {
  className?: string;
  color?: 'red' | 'black' | 'gray';
  size?: 'thin' | 'normal' | 'thick';
};

function LineDivider(props: LineDividerProps) {
  const { className = '', color = 'red', size = 'thin' } = props;

  return <div className={cn('LineDivider', color, size, className)} />;
}

export default LineDivider;
